module.exports = __webpack_public_path__ + "media/images/riders/small/CHARLIE_HARRISON-c8326f1a7817d45e7ceb0fd3a612dd42.png";